import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { apiRequest } from '../utils/api';
import { useAuth } from '../context/AuthContext';

export default function LoginPage(){
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { saveAuth } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    try{
      const data = await apiRequest('/users/login', 'POST', { email, password });
      saveAuth(data.token, data.user);
      nav('/dashboard');
    }catch(err){
      setError(err.message || 'Login failed');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="max-w-md w-full backdrop-blur-xl bg-white/10 border border-white/20 p-8 rounded-2xl shadow-2xl text-white">
        <h2 className="text-3xl font-extrabold mb-2 text-center bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-emerald-400">
          TaskMate
        </h2>
        <p className="text-gray-400 text-center mb-8 font-medium">Elevate your productivity</p>
        
        {error && (
          <div className="bg-red-500/20 border border-red-500/50 text-red-200 p-3 mb-6 rounded-xl text-sm animate-pulse">
            {error}
          </div>
        )}

        <form onSubmit={submit} className="space-y-5">
          <div>
            <label className="block text-xs uppercase tracking-widest text-gray-400 mb-2 ml-1 font-semibold">Email</label>
            <input 
              value={email} 
              onChange={e=>setEmail(e.target.value)} 
              className="w-full bg-white/5 border border-white/10 p-3 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/50 transition-all placeholder-gray-600"
              placeholder="name@example.com"
            />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-widest text-gray-400 mb-2 ml-1 font-semibold">Password</label>
            <input 
              value={password} 
              onChange={e=>setPassword(e.target.value)} 
              type="password" 
              className="w-full bg-white/5 border border-white/10 p-3 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/50 transition-all placeholder-gray-600"
              placeholder="••••••••"
            />
          </div>
          <button className="w-full bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-500 hover:to-blue-400 text-white py-3 rounded-xl font-bold shadow-lg shadow-blue-900/20 transition-all transform hover:scale-[1.02] active:scale-[0.98] mt-4">
            Sign In
          </button>
        </form>
        
        <div className="mt-8 text-center text-sm text-gray-400">
          New here? <Link to="/register" className="text-blue-400 hover:text-blue-300 font-bold transition-colors">Create account</Link>
        </div>
      </div>
    </div>
  );
}
